import { render } from "./FlashMessages.vue?vue&type=template&id=dbbc0bac&scoped=true"
import script from "./FlashMessages.vue?vue&type=script&lang=js"
export * from "./FlashMessages.vue?vue&type=script&lang=js"

import "./FlashMessages.vue?vue&type=style&index=0&id=dbbc0bac&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbbc0bac"]])

export default __exports__